import { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

export function SubscribeIconQuestion({
  size = 16,
  color = 'white',
  opacity = 1,
  ...props
}: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={opacity}
      {...props}
    >
      <g>
        <path
          d="M8 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8.00004C14.6663 4.31814 11.6816 1.33337 8 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8.00004C1.33337 11.6819 4.31814 14.6667 8 14.6667Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g>
          <path
            d="M8 10.6667V7.99996"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 5.33337H8.00017"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  )
}
